<template>
    <div :id="name" class="gallery my-10 pa-0">
        <v-card tile flat color="transparent" class="px-10 flex-fill">
            <v-card-title class="d-flex justify-center">
                <h2 :class="$mq.phone ? '' : !!$mq.tablet ? 'display-1' : 'display-2'">Réalisations</h2>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col
                        v-for="(item, n) in content.items"
                        :key="n"
                        class="d-flex justify-center"
                        :cols="cols"
                    >
                        <v-hover v-slot:default="{ hover }">
                            <v-card 
                                tile 
                                class="gallery-image d-flex align-end" 
                                style="position: relative;"
                                v-ripple="{ center: true }"
                                @click="run( 'openViewer', item )"
                            >
                                <v-img
                                    :src="item.thumbnail"
                                    class="grey lighten-2"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular indeterminate color="grey lighten-5" />
                                        </v-row>
                                    </template>

                                    <v-expand-transition>
                                        <div
                                            v-if="hover"
                                            class="gallery-image-desc d-flex flex-column transition-fast-in-fast-out v-card--reveal px-5 py-2 gray-75" 
                                        >
                                            <span class="custom-white-text">{{ item.title }}
                                                <span v-if="!!item.desc">
                                                    <br>
                                                    <small class="custom-white-text" v-html="item.desc" />
                                                </span>
                                            </span>
                                            <small v-if="!!item.dimensions" class="custom-white-text">{{ item.dimensions }}</small>
                                            <small v-if="!!item.location" class="custom-white-text">{{ item.location }}</small>
                                        </div>
                                    </v-expand-transition>
                                </v-img>
                            </v-card>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'Gallery',
    props: [
        'name',
    ],
    data() {
        return {
            simulateMany: false,
            show: {
                viewer: false,
                selection: null,
            }
        }
    },
    computed: {
        rows() { 
            return this.content.items.length / ( 12 / this.cols ) 
        },
        cols() {
            if( this.content.items.length > 1 ) return !!this.$mq.phone ? 12 : !!this.$mq.tablet ? 6 : 4
            else return !!this.$mq.phone ? 12 : !!this.$mq.tablet ? 8 : 5
        },
        content() {
            let content = {}

            switch( name ) {
                default:
                    content = {
                        title: `Réalisations`,
                        items: [
                            {
                                src: require(`@/assets/img/achievements-gallery/slide-1.jpg`),
                                w: 2500,
                                h: 1200,
                                thumbnail: require(`@/assets/img/achievements-gallery/thumbnail-1.jpg`),
                                title: `Socle de sculpture (2020)`,
                                desc: `portant une oeuvre du sculpteur <a target="_blank" href="https://www.matthieubinette.com/" title="Site web de l'artiste">Matthieu Binette</a>`,
                                dimensions: null,
                                location: `Tour d'habitation Humano, Sherbrooke, Qc`,
                            },
                            {
                                src: require(`@/assets/img/achievements-gallery/slide-2.jpg`),
                                w: 2500,
                                h: 1200,
                                thumbnail: require(`@/assets/img/achievements-gallery/thumbnail-2.jpg`),
                                title: `Agrandissement de résidence (2015)`,
                                desc: `Garage et chambre arrière`,
                                dimensions: null,
                                location: `Rue du Mont-Girard, St-Denis-de-Brompton, Qc`,
                            },
                        ]
                    }
            }

            if( !!this.simulateMany ) {
                for( let i = content.items.length; i < 9; i++ ) {
                    content.items.push( content.items[ 0 ] )
                }
            }

            return content
        }
    },
    methods: { 
        run( method, params = null ) {
            if( typeof this[ method ] === 'function' ) {
                !!params ? this[ method ]( params ) : this[ method ]()
            }
            else {
                this.$emit( 'run', method, params )
            }
        },
    },
  }
</script>

<style scoped>
.gallery {
    min-height: 50vh;
}

.gallery-image > * {
    transition: all .2s;
    cursor: pointer;
    overflow: hidden;
}
</style>
